import { mapGetters } from 'vuex'
import {parseValidations, parseValidationSetup, setValidationRule, Validators} from '../../lib/validations'

const validations = {
  firstName: setValidationRule('firstName'),
  lastName: setValidationRule('lastName'),
  phone: setValidationRule('phone'),
  phoneConfirmation: setValidationRule('phoneConfirmation', {
    confirmed: {error: 'Phone is not confirmed.', rule: Validators.sameAs('phone')},
  }),
  email: setValidationRule('email', {
    required: {error: 'Email is required.'},
    email: {error: 'Email is not valid.'},
  }),
  emailConfirmation:  setValidationRule('phoneConfirmation', {
    confirmed: {error: 'Email is not confirmed.', rule: Validators.sameAs('email')},
  }),
}

export default {
  data() {
    return {
      personalDetailsStepNumber: 2,
      useEmail: true,
      useConfirmation: false,
      showEmailBeforePhone: true,
      phoneConfirmation: null,
      emailConfirmation: null,
      validations: {},
      personalDetailsValidations() {
        let parsableValidations = _.cloneDeep(validations)
        if (!this.useEmail) {
          parsableValidations = _.omit(parsableValidations, ['email', 'emailConfirmation'])
        }
        if (!this.useConfirmation) {
          parsableValidations = _.omit(parsableValidations, ['phoneConfirmation', 'emailConfirmation'])
        }
        return {
          ...parseValidations(parsableValidations),
          personalDetails: _.keys(parsableValidations),
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck',
    }),
    disabledPersonalDetails() {
      return false
    },
    isPersonalDetailsInvalid() {
      return this.$v.personalDetails.$invalid
    },
    emailInputContainerClass() {
      //container-form__fields--odd
      //container-form__fields--even
      const showEmail = this.useEmail
      const showConfirmation = this.useConfirmation
      const showEmailBefore = this.showEmailBeforePhone
      const position = showConfirmation || (showEmail && showEmailBefore) ? 'odd' : 'even'
      return [`container-form__fields--${position}`]
    },
    phoneInputContainerClass() {
      const showEmail = this.useEmail
      const showConfirmation = this.useConfirmation
      const showEmailBefore = this.showEmailBeforePhone
      const position = showConfirmation || !(showEmail && showEmailBefore) ? 'odd' : 'even'
      return [`container-form__fields--${position}`]
    },
  },
  validations() {
    return {
      ...this.addedValidations()
    }
  },
  created() {
    this.validations = parseValidationSetup(validations, this)
    if (this.authenticated) {
      this.firstName = this.user.first_name
      this.lastName = this.user.last_name
      this.phone = this.phoneConfirmation = this.user.meta.phone
      if (this.useEmail) {
        this.emailConfirmation = this.email = this.user.email
      }
    }
  },
  mounted() {
    this.$v.$reset()
  },
  methods: {
    addedValidations() {
      return this.personalDetailsValidations()
    },
  }
}
